export default "__VITE_ASSET__hZgUmaOY__"